import React, { createContext, useState, useContext } from "react";

// Create Context
const WheelSegmentsContext = createContext();

// Provider Component
export const WheelSegmentsProvider = ({ children }) => {
  const [segments, setSegments] = useState([]);
  const [wheelData, setWheelData] = useState({});

  const addWheelData = (data) => {
    setWheelData(data);
  };

  const getWheelData = () => {
    return wheelData;
  };

  const addSegments = (segments) => {
    setSegments(segments);
  };

  const getSelectedSegment = () => {
    return segments.find((segment) => segment.selected === true);
  };

  return (
    <WheelSegmentsContext.Provider
      value={{
        segments,
        wheelData,
        addSegments,
        getSelectedSegment,
        addWheelData,
        getWheelData,
      }}
    >
      {children}
    </WheelSegmentsContext.Provider>
  );
};

// Hook for accessing the context
export const useWheelSegments = () => {
  return useContext(WheelSegmentsContext);
};
